import { useQuery } from '@tanstack/react-query';
import API from '../../../context/API';
import type { Category } from '../store/userStoresSlice';

export const STORE_CATEGORIES_QUERY_KEY = ['store-categories'] as const;

export const useStoreCategories = () => {
  return useQuery<Category[]>({
    queryKey: STORE_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const res = await API.get('/categories');
      return res.data.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
